export const noticeToShareHolders = "NOTICE_TO_SHAREHOLDERS";
